// extracted by mini-css-extract-plugin
export default {"note":"EditNotePopoverSection_note__2xogp","saveButton":"EditNotePopoverSection_saveButton__0LU4c"};